<div class="modal">
  <div class="modal-header">
    <div class="modal-header-txt">Confirm the precautions</div>
    <div style="position:relative">
      <div class="title-close"><i class="material-icons" (click)="closeModal()">close</i></div>
    </div>
  </div>
  <div class="items-area">
    <div class="item">
      <div class="item-label">Selected Plan</div>
      <div style="margin: 4px">
        <div style="display: flex; align-items: center;">
          <div class="badge">{{selectedPlanTitle}}</div>
          <div class="text-blue-gray-higher">{{selectedPlanFee}} / month</div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="item-label">Precaution</div>
      <div style="margin: 4px">
        <div class="precaution-area">
          <div class="precaution"><i class="material-icons precaution-icon">check</i><span class="description">New features are available immediately after upgrade.</span></div>
          <div class="precaution"><i class="material-icons precaution-icon">check</i><span class="description">The rates for the plans are a monthly rate for your CHeKT Dealer account.</span></div>
          <div class="precaution" *ngIf="dealerType() === 2"><i class="material-icons precaution-icon">check</i><span class="description">Once your account is upgraded your account can not be downgraded to the Basic Plan. </span></div>
        </div>
        <div style="margin-top: 16px;">
          <mat-checkbox style="color:hsla(0,0%,0%,0.87);" [(ngModel)]="checked" [labelPosition]="'after'">You are aware of all these things and proceed.</mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="tail-btn-area">
    <div class="button button-primary" [class.disabled]="!checked" (click)="onClickConfirmPrecaution()">
      <div class="btn-inner">Confirm</div>
    </div>
    <div class="button" (click)="closeModal()">
      <div class="btn-inner">Cancel</div>
    </div>
  </div>
</div>